import {
  businessLocationAddonMapper,
  familyLocationAddonMapper,
  isFamilyPlan,
  isBusinessPlan,
  isTierOneAddon,
  isPersonalPlan,
  isCurrentPlan,
} from '../locale';
import { AccountType, AccountTypeEnum, ClimateStatus, User } from './types';

export const isBusinessAccountType = (accountType: AccountType | null | undefined): boolean =>
  accountType === AccountTypeEnum.BUSINESS || accountType === AccountTypeEnum.LIKELY_BUSINESS;

/**
 * Fails closed: only accounts clearly marked as individuals show personal names publicly.
 * Business, likely-business, and missing/unknown account types all hide names.
 */
export const isPublicNameVisible = (accountType: AccountType | null | undefined): boolean =>
  accountType === AccountTypeEnum.INDIVIDUAL || accountType === AccountTypeEnum.LIKELY_INDIVIDUAL;

const emptyFamilyPlan = { adults: 0, children: 0, pets: 0 };
const emptyBusinessPlan = { tier1: 0, tier2: 0, tier3: 0 };

export const BAFTA_USERNAME = 'wearealbert';
export const isBaftaUser = (user: User) => user.parentProfile?.username === BAFTA_USERNAME;

export const getPlanAddonsForFamilyUser = (user: User) => {
  const plan = { ...emptyFamilyPlan };

  if (!user.subscription) {
    return plan;
  }

  const addonsForLocation = familyLocationAddonMapper[user.location];

  user.subscription.addons.forEach(addon => {
    if (addon.id === addonsForLocation.adults.id) {
      plan.adults = addon.quantity;
      return;
    }
    if (addon.id === addonsForLocation.children.id) {
      plan.children = addon.quantity;
      return;
    }
    if (addon.id === addonsForLocation.pets.id) {
      plan.pets = addon.quantity;
      return;
    }
  });

  return plan;
};

export const getPlanAddonsForBusinessUser = (user: User) => {
  const plan = { ...emptyBusinessPlan };

  if (!user.subscription) {
    return plan;
  }

  const addonsForLocation = businessLocationAddonMapper[user.location];

  user.subscription.addons.forEach(addon => {
    if (addon.id === addonsForLocation.tier1.id) {
      plan.tier1 = addon.quantity;
      return;
    }
    if (addon.id === addonsForLocation.tier2.id) {
      plan.tier2 = addon.quantity;
      return;
    }
    if (addon.id === addonsForLocation.tier3.id) {
      plan.tier3 = addon.quantity;
      return;
    }
  });

  return plan;
};

export const getClimateStatus = (planId: string, addons: string[]): ClimateStatus => {
  // Family is always friendly right now
  if (isFamilyPlan(planId)) return ClimateStatus.FRIENDLY;

  if (isBusinessPlan(planId)) {
    // Any tier 1 addons mean status is friendly
    if (addons?.some(id => isTierOneAddon(id))) {
      return ClimateStatus.FRIENDLY;
    }

    // Otherwise positive
    return ClimateStatus.POSITIVE;
  }

  // personal v3 is friendly and all other personal plans are positive
  if (isPersonalPlan(planId) && isCurrentPlan(planId)) {
    return ClimateStatus.FRIENDLY;
  }

  return ClimateStatus.POSITIVE;
};
